















































































import axios from "axios";
import lodash from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { restApi } from "@/rest-api";
import { AppState } from "../store/modules/count";

@Component
export default class StatusBar extends Vue {
  toggleDarkMode() {
    let appSettings = this.$store.state.appSettingsModule.appSettings;
    appSettings.isDarkMode = !appSettings.isDarkMode;
    this.$store.commit("appSettingsModule/SET_APP_SETTINGS", appSettings);
  }

  // get gantryVoltage() {
  //   if (this.$store.state.statusBarModule.gantryVoltage === undefined) {
  //     return "";
  //   } else {
  //     return this.$store.state.statusBarModule.gantryVoltage + " V"
  //   }
  // }
  gantryVoltage = "";

  clickGantry() {
    if (this.checkHardwareStatusDebounced !== null) {
      this.checkHardwareStatusDebounced.flush();
    }

    // let address = this.$store.state.appSettings.hardwareServerAddress;
    // let restfulPort = this.$store.state.appSettings.hardwareServerRestfulPort;
    // let url = `https://${address}:${restfulPort}${restApi.apiGantryVoltage}`;

    // axios
    //   .get(url)
    //   .then(response => {
    //     console.log(response);
    //     this.$store.commit("statusBarModule/SET_GANTRY_VOLTAGE", response.data);
    //     this.gantryVoltage = this.$store.state.statusBarModule.gantryVoltage + " V";
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   })

    //console.log("gantry click");
  }

  errorConnecting: boolean = false;

  checkHardwareStatusDebounced: any = null;
  async checkHardwareStatus() {
    let address = this.$store.state.appSettingsModule.appSettings.hardwareServerAddress;
    let restfulPort = this.$store.state.appSettingsModule.appSettings.hardwareServerRestfulPort;
    let restfulProtocol = this.$store.state.appSettingsModule.appSettings.getRestfulProtocol();
    //let url = `https://${address}:${restfulPort}${restApi.apiGantryVoltage}`;
    let url = `${restfulProtocol}://${address}:${restfulPort}${restApi.apiGantryVoltage}`;

    try {
      let response = await axios.get(url, { timeout: 5000 });
      this.errorConnecting = false;
      this.$store.commit("statusBarModule/SET_GANTRY_VOLTAGE", response.data);
      this.gantryVoltage = this.$store.state.statusBarModule.gantryVoltage + " V";
    } catch (error) {
      console.log("checkHardwareStatus error");
      this.gantryVoltage = "NA";

      if (!this.errorConnecting) {
        //only do this first time there's an error found
        let appState: AppState = this.$store.state.countModule.appState;

        switch (appState) {
          case "connecting":
          case "connected":
          case "stopping_before_counting":
            //case "stopped_before_counting":
            this.$store.commit("countModule/SET_APP_STATE", "stopped_before_counting");
            break;

          case "counting":
          case "stopping_counting":
          //case "stopped_counting":
          case "resuming_counting":
            this.$store.commit("countModule/SET_APP_STATE", "stopped_counting");
            break;
        }
      }

      this.errorConnecting = true;
    }

    // axios
    //   .get(url, { timeout: 5000 })
    //   .then(response => {
    //     //console.log(response);
    //     this.$store.commit("statusBarModule/SET_GANTRY_VOLTAGE", response.data);
    //     this.gantryVoltage = this.$store.state.statusBarModule.gantryVoltage + " V";
    //   })
    //   .catch(error => {
    //     //console.log(error);
    //     console.log("checkHardwareStatus error");
    //     this.gantryVoltage = "NA";
    //   }).finally(() => {
    //     this.checkHardwareStatusDebounced = lodash.debounce(this.checkHardwareStatus, 1000);
    //     this.checkHardwareStatusDebounced();
    //   })

    this.checkHardwareStatusDebounced = lodash.debounce(this.checkHardwareStatus, 5000);
    this.checkHardwareStatusDebounced();

    // if (this.$store.state.countModule.webSocket) {
    //   console.log("readyState: " + this.$store.state.countModule.webSocket.readyState);
    // } else {
    //   console.log("no readyState");
    // }
  }

  connectionActivityLightColour: "grey" | "lime" | "red" = "grey";

  toggleConnectionActivityLightColour() {
    if (this.connectionActivityLightColour === "grey") {
      this.connectionActivityLightColour = "lime";
    } else {
      this.connectionActivityLightColour = "grey";
    }
  }

  //connectionActivityLightDebouned: any = null;
  connectionActivityLight() {
    let isWebSocketOpen: boolean =
      this.$store.state.countModule.webSocket && this.$store.state.countModule.webSocket.readyState === 1;
    if (
      !this.errorConnecting &&
      isWebSocketOpen &&
      (this.$store.state.countModule.appState === "connected" || this.$store.state.countModule.appState === "counting")
    ) {
      this.toggleConnectionActivityLightColour();
      lodash.debounce(this.connectionActivityLight, 100)();
    } else {
      if (!isWebSocketOpen || this.errorConnecting) {
        this.connectionActivityLightColour = "red";
      } else {
        this.toggleConnectionActivityLightColour();
      }
      lodash.debounce(this.connectionActivityLight, 1000)();
    }
  }

  async mounted() {
    console.log("status bar mounted");
    lodash.debounce(this.checkHardwareStatus, 5000)();
    this.connectionActivityLight();
  }
}
